import { apiClient } from "./index";

class crossSaleService {
  static getUUID() {
    return localStorage.getItem("user_uuid");
  }

  static getCrossSaleAfterOrder(orderId: any, productId: any, useTotalOrderPrice: boolean = false) {
    const params: any = {};
    if (useTotalOrderPrice) {
      params.use_total_order_price = true;
    }

    return apiClient.get(`orders/${orderId}/available-cross-sells`, {
      headers: {
        "X-Device": crossSaleService.getUUID(),
        "x-product-id": productId,
      },
      params: params
    });
  }

  static updateOrderValue(order_id: any, payload: any, productId: any) {
    return apiClient.post(`orders/${order_id}/add-cross-sells`, payload, {
      headers: {
        "X-Device": crossSaleService.getUUID(),
        "x-product-id": productId,
      },
    });
  }

}
export default crossSaleService;
